import DropdownSelection from 'app/models/dropdown_selection';

export default DropdownSelection.extend({
  initialize({
    choices, staticChoices = [], paramKey, label, staticKey, initialChoice, remoteCollection,
  }) {
    this.staticChoices = staticChoices;
    this.choices = choices || this.staticChoices.slice();
    this.paramKey = paramKey;
    this.label = label;
    this.staticKey = staticKey;
    this.setCurrentChoice(initialChoice);

    this.remoteCollection = remoteCollection;
    this.listenTo(this.remoteCollection, 'sync', this.setChoices);
    this.remoteCollection.resetToFirstPage();
  },

  setChoices() {
    this.choices = [
      ...this.staticChoices,
      ...this.remoteCollection.fullCollection.models.map(carrier => ({
        option: carrier.get('id'), readable: carrier.get('name'),
      })),
    ];
    this.trigger('change');
  },
});



// WEBPACK FOOTER //
// ./app/models/dropdown_selection_from_remote.js